import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PatientFinancialService } from './patient-financial.service';
import { PatientFinancalBillingService } from './patient-financal-billing.service';
import { receiptPdfData } from '../utils/receipt-payment-method';

/** Corrects the payment method on a captured receipt and redraws every receipt PDF for that payment. */
@Injectable({ providedIn: 'root' })
export class ReceiptPaymentMethodService {
  constructor(
    private financial: PatientFinancialService,
    private billing: PatientFinancalBillingService,
  ) {}

  /** A receipt that cannot be redrawn keeps its old PDF and is counted as failed. */
  async change(record: any, method: string, group: any): Promise<{ redrawn: number; failed: number }> {
    const response: any = await firstValueFrom(this.financial.changePaymentMethod(record.PatientPayment.id, group.id, method));
    const payment = response.data;
    let redrawn = 0;
    let failed = 0;
    for (const receipt of payment.receipts || []) {
      const data = receiptPdfData(receipt, payment, group);
      if (!data) {
        failed++;
        continue;
      }
      const pdfBytes = await this.billing.generateReceiptPDF(receipt.id, data);
      const pdfBlob = new Blob([pdfBytes as any], { type: 'application/pdf' });
      const fileName = `Receipt-${payment.Patient.name}-${payment.Patient.surname}_${Date.now()}.pdf`;
      await firstValueFrom(this.financial.uploadBillingDocumentPDF(receipt.id, group.id, pdfBlob, fileName, true));
      redrawn++;
    }
    return { redrawn, failed };
  }
}
